<template>
  <div class="app-container pull-auto">
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @current-change="currentChange"
                 @refresh-change="refreshChange"
                 @size-change="sizeChange"
                 @row-del="rowDel">
        <template slot-scope="scope"
                  slot="menu">
          <el-button type="danger"
                     v-if="permissions.sys_client_del"
                     icon="el-icon-delete"
                     size="mini"
                     plain
                     @click="handleDel(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
  </div>
</template>

<script>
  import { fetchList, delObj } from '@/api/admin/token'
  import { tableOption } from '@/const/crud/token'
  import { mapGetters } from 'vuex'
  export default {
    name: 'token',
    data() {
      return {
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        tableLoading: false,
        tableOption: tableOption
      }
    },
    created() {
      this.getList()
    },
    mounted: function() { },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      getList() {
        this.tableLoading = true
        fetchList({
          current: this.page.currentPage,
          size: this.page.pageSize
        }).then(response => {
          this.tableData = response.data.data.records
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      currentChange(val) {
        this.page.currentPage = val
        this.getList()
      },
      sizeChange(val) {
        this.page.pageSize = val
        this.getList()
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      rowDel: function(row, index) {
        var _this = this
        this.$confirm('是否确认删除ID为' + row.token_value, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(function() {
            return delObj(row.token_value)
          })
          .then(data => {
            _this.tableData.splice(index, 1)
            _this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success'
            })
          })
          .catch(function(err) { })
      },
      /**
       * 刷新回调
       */
      refreshChange() {
        this.getList()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>

